{
  "COMMON": {
    "SAVE": "Save",
    "SAVE_AND_CONTINUE": "Save and continue",
    "NEXT": "Next",
    "BACK": "Back",
    "EDIT": "Edit",
    "CANCEL": "Cancel",
    "CLOSE": "Close",
    "DELETE": "Delete",
    "INVALID_FORM": "Form is invalid",
    "ERROR_OCCURRED": "An error occurred",
    "YES": "Yes",
    "NO": "No",
    "NO_RESULTS": "No results",
    "RETRY": "Retry",
    "UPLOADING": "Uploading...",
    "DISMISS": "Dismiss",
    "SEARCH": "Search"
  },
  "AI_KNOWLEDGE_BASE": "AI knowledge collection",
  "KNOWLEDGE_COLLECTIONS": {
    "CONNECT": "Connect a knowledge collection",
    "REMOVE": "Remove knowledge collection",
    "EMPTY": "No knowledge collections connected.",
    "NONE_AVAILABLE": "No knowledge collections available to connect",
    "ERROR_LOADING": "An error occurred while loading knowledge collections"
  },
  "KNOWLEDGE": "Knowledge",
  "MANAGE_KNOWLEDGE": "Manage knowledge",
  "MANAGE_KNOWLEDGE_DESCRIPTION": "Provide information AI can use when creating content or answering inquiries",
  "REFRESH_OPTIONS": "Refresh options",
  "KNOWLEDGE_SOURCES": "Knowledge sources",
  "ADD_KNOWLEDGE": "Add knowledge",
  "ADD_NEW_KNOWLEDGE": "+ Add new knowledge",
  "SELECT_KNOWLEDGE": "Select knowledge",
  "ERROR_LOADING_KNOWLEDGE": "An error occurred while loading knowledge",
  "APPLICATION_SETTINGS": "Settings",
  "APPS_WARNING": "This knowledge will be removed from the following:",
  "NO_APPS": "This knowledge is not currently being used.",
  "NO_MATCHING_KNOWLEDGE_SOURCES": "No knowledge available",
  "SUGGESTED": "Suggested",
  "WEBSITE_SCRAPE": {
    "SCRAPE_NOT_DONE": "Finding pages...",
    "TRAINING_NOT_DONE": "Training pages...",
    "LAST_SCRAPED": "Last refreshed {{lastScraped}}",
    "NUMBER_OF_PAGES_TRAINED": "Trained on {{trainedPagesCount}} of {{scrapedPagesCount}} pages",
    "RESCRAPE": "Refresh",
    "RESCRAPE_PAGES": "Refresh pages",
    "RESCRAPE_ALL_PAGES": "Refresh all pages",
    "RESCRAPE_CONFIRMATION": {
      "TITLE": "Refresh this website?",
      "MESSAGE": "This will update the content from the website. Pages found previously will be replaced.",
      "MESSAGE_LOSE_CHANGES": "Any unsaved changes will be lost"
    },
    "EXCLUDED_PATHS": {
      "TITLE": "Excluded paths",
      "DESCRIPTION": "URLs that contain these paths will be skipped.",
      "INVALID": "Enter a relative path that starts with /, like /blog or /admin"
    },
    "ENABLE_AUTOMATIC_RESCRAPE": "Enable automatic refresh",
    "AUTOMATIC_RESCRAPE_ENABLED": "Refreshes automatically on {{date}}",
    "TRAINING_IN_PROGRESS_TOOLTIP": "Training is still in progress. Knowledge will be available to employees after training is complete.",
    "DISABLE": "Disable",
    "ERRORS": {
      "TITLE": "Unable to find pages for {{ url }}",
      "ERROR": "You can go back and change it or try again if this looks correct",
      "SITEMAP_INDIRECT": "Did not find a sitemap (.xml or robots.txt) at {{ url }}. Provide a direct URL to the sitemap or try a different method.",
      "SCRAPING_PROTECTION": "This website uses scraping protection that is preventing access. You can try adding the content manually instead.",
      "ACTIONS": {
        "TRY_AGAIN": "Try again",
        "GO_BACK": "Go back"
      },
      "DESCRIPTION": "Failed to find page"
    }
  },
  "EDIT_KNOWLEDGE": {
    "TITLE": "Edit knowledge",
    "NAME": "Name",
    "NO_KNOWLEDGE": "No knowledge yet.",
    "CUSTOM_DATA_CONFIG": {
      "TITLE": "Text",
      "DESCRIPTION": "Content related to your business such as FAQs or custom information",
      "CONTENT": "Content",
      "CONTENT_HINT": "Provide frequently asked questions and answers or other text the AI can use in responses. This does not give special instructions to AI"
    },
    "WEBSITE_SCRAPE_CONFIG": {
      "TITLE": "Website",
      "DESCRIPTION": "Retrieve content from a website",
      "URL": "URL",
      "INVALID_URL": "Please enter a valid URL",
      "CRAWL_MODE": "Mode",
      "SINGLE_PAGE": "Single page",
      "FOLLOW_LINKS": "Follow links",
      "FOLLOW_LINKS_HINT": "Will find up to {{pageLimit}} pages by following links from this domain starting on the provided URL",
      "SITEMAP": "Sitemap",
      "SITEMAP_HINT": "Uses sitemap (.xml or robots.txt) to find up to {{pageLimit}} pages. You may optionally provide the sitemap URL, or we'll try to find it on the provided URL",
      "URL_HINT": "The URL must be publicly accessible. A URL is publicly accessible if you can access it in incognito mode (in Chrome) or private browsing mode (in Safari/Firefox) without logging in.",
      "PAGES": "Pages",
      "NUMBER_OF_PAGES_TRAINED": "Trained on {{trainedPagesCount}} of {{scrapedPagesCount}} pages",
      "SELECT_PAGES_TO_TRAIN": "Choose pages to train on:",
      "SELECT_PAGES_TO_REFRESH": "Choose pages to refresh:",
      "SELECT_ALL": "Select all",
      "SELECT_NONE": "Select none",
      "PAGE_COUNT": "Pages: {{scrapedPagesCount}}",
      "PAGES_SELECTED": "{{selectedPagesCount}} selected",
      "UNABLE_TO_LOAD": "Unable to load",
      "SCRAPE_WILL_BE_QUEUED": "Knowledge will be retrieved after widget is created",
      "SCRAPE_QUEUED": "Finding pages...",
      "SCRAPE_IN_PROGRESS": "Pages found: ",
      "SCRAPE_IN_PROGRESS_CLARIFICATION_DEFAULT": "This may take a few minutes. Pages will appear here when done. You can close this panel and continue later without losing progress.",
      "REFRESH": "Refresh",
      "PAGE_TITLE": "Page title",
      "FIND_PAGES": "Find pages",
      "TRAIN": "Train",
      "MY_WEBSITE": "My Website"
    },
    "FILE_UPLOAD_CONFIG": {
      "TITLE": "File Upload",
      "DESCRIPTION": "Upload a document or file to provide as knowledge",
      "UPLOAD_FILES": "Upload file",
      "SELECT_FILE": "Select file to upload",
      "NAME_PLACEHOLDER": "Will be auto-filled from file name",
      "HINT_TEXT": "Supported formats: PDF, DOCX, HTML, Images (JPG, PNG), TXT, CSV, Markdown, JSON, PowerPoint (PPTX), Excel (XLS, XLSX) (max 100MB)",
      "DRAG_DROP_SINGULAR": "Drag and drop a file here",
      "CHOOSE_FILE_SINGULAR": "Choose file",
      "UPLOADED_FILE": "Uploaded file",
      "CURRENT_FILE": "Current file",
      "ERRORED_FILE": "Failed file",
      "VIEW_FILE": "View file",
      "DOWNLOAD_FILE": "Download file",
      "UPLOAD_NEW_TO_REPLACE": "Upload a new file to replace the current one",
      "UPLOAD_SUCCESS": "File uploaded successfully",
      "UPLOAD_ERROR": "File upload failed",
      "FILE_REPLACED": "File replaced successfully",
      "NO_FILE_UPLOADED": "Please upload a file",
      "UPLOAD_PROCESSING": "Please wait for file processing to complete"
    },
    "TRAINING": {
      "TRAINING_DONE": "Training complete",
      "TRAINING_QUEUED": "Training queued",
      "TRAINING_IN_PROGRESS_PAGES": "Pages trained: ",
      "TRAINING_IN_PROGRESS_PERCENT": "Training in progress: ",
      "TRAINING_IN_PROGRESS_CLARIFICATION": "This may take a few minutes. After training, select where to use the new knowledge. You can close this panel and continue later.",
      "INITIAL_TRAINING": "This training was automatically started for you. It will train the main page for the provided URL. You can add more pages when this is done.",
      "TRAINING_IN_PROGRESS_TOOLTIP": "Training is in progress. Knowledge will be available to employees after training is complete.",
      "TRAINING_DONE_TOOLTIP": "This knowledge is ready to be used",
      "TRAINING_ERRORED": "Training failed",
      "TRAINING_DISMISSABLE_ERROR_DESCRIPTION": "There was an error while training this knowledge source, the previously trained version will continue to be used. You can dismiss this error or upload a new file to try again.",
      "TRAINING_NON_DISMISSABLE_ERROR_DESCRIPTION": "There was an error while training this knowledge source. You must upload a new file to try again.",
      "ERROR_LARGE_FILE_CONTENT": "The file content is too large to process. Please try a smaller file or reduce the content.",
      "ERROR_UNPROCESSIBLE_FILE_CONTENT": "The file content is empty or cannot be processed. Please check that the file contains readable text.",
      "ERROR_UNKNOWN": "An unknown error occurred during training. Please try uploading the file again."
    },
    "REQUIRED_FIELD": "Required",
    "FIELD_REQUIRED": "This field is required",
    "ENTER_KNOWLEDGE": "Enter knowledge",
    "ADD_TO_AI": "Add to AI",
    "SUCCESSFULLY_SAVED": "Knowledge saved",
    "OTHER_AI": "Changes made here will also apply to {{count}} other AI"
  },
  "DELETE_KNOWLEDGE": {
    "TITLE": "Delete custom knowledge?",
    "SUCCESSFULLY_DELETED": "Knowledge deleted"
  },
  "DELETE_KNOWLEDGE_BASE": {
    "TITLE": "Delete knowledge base?",
    "MESSAGE": "This permanently deletes \"{{name}}\". The knowledge sources inside it aren't deleted. This can't be undone.",
    "SUCCESSFULLY_DELETED": "Knowledge base deleted",
    "ERROR": "Couldn't delete knowledge base. Please try again.",
    "HAS_GRANTS_ERROR": "This knowledge base is still shared. Remove all of its shares, then delete it."
  },
  "APPLICATION_SELECTOR": {
    "NO_APPS_TITLE": "Create your first AI enabled application",
    "NO_APPS_BODY": "A Web Chat widget can use this knowledge to answer inquires from visitors on your website.",
    "CREATE_WIDGET": "Create widget",
    "ADD_KNOWLEDGE_TO": "Add knowledge to:",
    "PLACEHOLDER": "Choose applications..."
  },
  "BUSINESS_PROFILE": {
    "SHARE_FIELDS": "Share Business Profile fields with your AI employee",
    "SHARE_FIELDS_TOOLTIP": "Information shared: business name, address and/or service areas, website, email, phone number, categories, hours, services offered, short description, long description, social media URLs, and booking URL.",
    "BUSINESS_PROFILE": "Business Profile",
    "ALLOW_ACCESS": "Allow access to your business profile",
    "DESCRIPTION": "Answer questions about your business contact information, hours, products and services you offer.",
    "MANAGE_BUSINESS_PROFILE": "Manage business profile"
  },
  "UNSAVED_CHANGES": {
    "TITLE": "Unsaved changes",
    "MESSAGE": "Are you sure you want to leave? You will lose any unsaved changes."
  },
  "CREATE_WEB_CHAT_WIDGET": {
    "LOADING_DESCRIPTION": "Creating web chat widget...",
    "SUCCESS": {
      "TITLE": "Web chat widget successfully created",
      "KEEP_EDITING": "Keep editing",
      "GO_TO_WEB_CHAT_SETTINGS": "Go to web chat settings"
    },
    "ERROR": {
      "TITLE": "An error occurred while creating the web chat widget",
      "MESSAGE": "Try again?",
      "YES": "Retry create widget"
    },
    "NO_WEB_CHAT_WIDGET": {
      "TITLE": "There are no Web Chat widgets to add this knowledge to",
      "BODY": "Would you like to create one now?",
      "YES": "Yes, create widget"
    }
  },
  "KNOWLEDGE_SHARING": {
    "CREATE": {
      "TITLE": "Create knowledge collection",
      "LEDE": "A knowledge collection groups related knowledge sources so they can be referenced — and shared — together.",
      "NAME": "Name",
      "NAME_PLACEHOLDER": "e.g. Customer service FAQs",
      "DESCRIPTION": "Description (optional)",
      "DESCRIPTION_PLACEHOLDER": "What kind of knowledge is in this collection?",
      "SOURCES_TITLE": "Knowledge sources",
      "SOURCES_HINT": "Pick which existing sources go in this knowledge collection. You can add more later.",
      "SEARCH_PLACEHOLDER": "Search by name",
      "NO_MATCHING_SOURCES": "No matching sources.",
      "NO_SOURCES_SELECTED": "No sources selected",
      "SOURCES_SELECTED": "{{count}} sources selected",
      "CREATE": "Create",
      "CREATE_ERROR": "Couldn't create knowledge base. Please try again."
    },
    "SOURCES": {
      "MANAGED_BY": "Managed by {{partner}}",
      "READONLY_LEDE": "This knowledge collection is managed by {{partner}}. You can use it as-is, but its sources can't be edited here.",
      "EMPTY_READONLY": "No knowledge sources in this knowledge collection.",
      "EDIT_LEDE": "Check a source to add it to this knowledge collection. Uncheck to remove.",
      "SEARCH_PLACEHOLDER": "Search by name",
      "NO_MATCHING_SOURCES": "No matching sources.",
      "COUNT_ONE": "{{count}} source in this knowledge collection",
      "COUNT_OTHER": "{{count}} sources in this knowledge collection",
      "APPLY": "Apply",
      "SAVE_ERROR": "Couldn't update knowledge sources. Please try again."
    },
    "SHARE": {
      "TITLE": "Share knowledge collection",
      "CURRENT_SHARES": "Current shares",
      "CURRENT_SHARES_COUNT": "Current shares ({{count}})",
      "LOAD_ERROR_SUFFIX": "You can still add new shares below.",
      "NO_SHARES": "No active shares yet. Pick a target below to add one.",
      "REVOKE_SHARE": "Revoke share",
      "BLOCKED_TITLE": "Can't revoke yet — dependents would be orphaned",
      "APPS_USING_ONE": "{{count}} app still uses this knowledge collection",
      "APPS_USING_OTHER": "{{count}} apps still use this knowledge collection",
      "DETACH_APPS_ONE": "Detach {{count}} app",
      "DETACH_APPS_OTHER": "Detach {{count}} apps",
      "DETACH_APPS_CONFIRM_ONE": "Detach {{count}} app?",
      "DETACH_APPS_CONFIRM_OTHER": "Detach {{count}} apps?",
      "DOWNSTREAM_ONE": "{{count}} downstream re-share",
      "DOWNSTREAM_OTHER": "{{count}} downstream re-shares",
      "REVOKE_DOWNSTREAM": "Revoke {{count}} downstream",
      "REVOKE_DOWNSTREAM_CONFIRM_ONE": "Revoke {{count}} downstream re-share?",
      "REVOKE_DOWNSTREAM_CONFIRM_OTHER": "Revoke {{count}} downstream re-shares?",
      "CONFIRM": "Confirm",
      "CANCEL_REVOKE": "Cancel revoke",
      "ADD_TARGETS": "Add targets",
      "READONLY": "Sharing is read-only from this surface — no target types are available.",
      "TARGET_TYPE": "Target type",
      "SEARCH_PLACEHOLDER": "Search for a name",
      "NO_MATCHES": "No matches.",
      "NO_TARGETS_SELECTED": "No targets selected",
      "TARGETS_SELECTED": "{{count}} selected",
      "SHARING": "Sharing…",
      "TARGET_TYPE_ACCOUNT": "Account",
      "TARGET_TYPE_ML_GROUP": "Multi-location group",
      "TARGET_TYPE_PARTNER": "Partner",
      "TARGET_TYPE_ALL_ACCOUNTS": "All Accounts under this partner",
      "TARGET_TYPE_ALL_ACCOUNTS_UNDER_PARTNER": "All accounts under a partner",
      "TARGET_TYPE_ALL_PARTNERS": "All Partners (broadcast)",
      "TARGET_TYPE_ALL_ACCOUNT_GROUPS_GLOBAL": "All account groups (platform-wide)",
      "ALL_ACCOUNTS_NAME": "All Accounts under this partner",
      "ALL_ACCOUNTS_SUBTITLE": "Visible to every account below this partner",
      "ALL_ACCOUNTS_UNDER_PARTNER_SUBTITLE": "All accounts under this partner",
      "ALL_PARTNERS_NAME": "All Partners on the platform",
      "ALL_PARTNERS_SUBTITLE": "Every partner namespace platform-wide",
      "ALL_ACCOUNT_GROUPS_GLOBAL_NAME": "All account groups on the platform",
      "ALL_ACCOUNT_GROUPS_GLOBAL_SUBTITLE": "Every account group across every partner",
      "LOAD_SHARES_ERROR": "Couldn't load existing shares.",
      "SHARE_ERROR": "Couldn't share knowledge collection. Please try again.",
      "SHARE_PARTIAL_ERROR": "Shared with {{shared}}, but {{failed}} couldn't be shared. Please try again.",
      "REVOKE_ERROR": "Couldn't revoke share. Please try again.",
      "DETACH_APPS_ERROR": "Couldn't detach apps. Please try again.",
      "REVOKE_DOWNSTREAM_ERROR": "Couldn't revoke downstream re-shares. Please try again.",
      "APPLY": "Apply"
    },
    "DETAIL": {
      "BACK": "Back to Knowledge Collections",
      "DESCRIPTION_LABEL": "Description",
      "SHARED_WITH": "Shared with",
      "SHARED_WITH_HINT": "Namespaces and partners that can use this knowledge collection",
      "NO_SHARES": "Not shared with anyone yet.",
      "SOURCES": "Sources",
      "SOURCES_HINT": "Knowledge sources included in this collection",
      "SHOW_ALL": "Show all ({{count}})",
      "SHOW_LESS": "Show less",
      "NO_SOURCES": "No sources in this knowledge collection yet.",
      "ADD_SOURCE": "Add sources",
      "MANAGED_BY_BANNER": "This knowledge collection is managed by {{partner}}. You can use it as-is, but its sources can't be edited or removed here.",
      "GRANTED_ON": "Shared {{date}}",
      "MANAGE_SHARING": "Manage sharing",
      "NOT_FOUND_TITLE": "Knowledge collection not found",
      "NOT_FOUND_DESCRIPTION": "It may have been deleted, or you may not have access to it.",
      "LOAD_ERROR_TITLE": "Couldn't load this knowledge collection",
      "LOAD_ERROR_DESCRIPTION": "Something went wrong while loading it. Please try again.",
      "RETRY": "Retry",
      "REMOVE_SOURCE_TITLE": "Remove source from collection?",
      "REMOVE_SOURCE_MESSAGE": "\"{{source}}\" will be removed from \"{{kb}}\". The source itself stays in your library — only its membership in this collection is removed.",
      "REMOVE_SOURCE_CONFIRM": "Remove",
      "REMOVE_SOURCE_SUCCESS": "Removed \"{{source}}\" from \"{{kb}}\".",
      "REMOVE_SOURCE_ERROR": "Couldn't remove the source. Please try again.",
      "REVOKE_BLOCKED": "\"{{target}}\" can't be unshared yet — other shares or apps still depend on it. Cleaning those up needs a follow-up action that isn't available yet."
    },
    "BASE_TABLE": {
      "CREATE": "Add collection",
      "COL_NAME": "Name",
      "COL_DESCRIPTION": "Description",
      "COL_SOURCES": "Sources",
      "COL_MANAGED_BY": "Managed by",
      "COL_LAST_MODIFIED": "Last modified",
      "ROW_ACTIONS": "Row actions",
      "SHARE": "Share",
      "DELETE_TITLE": "Delete knowledge collection?",
      "DELETE_MESSAGE": "\"{{name}}\" will be permanently deleted. Its knowledge sources are not deleted.",
      "DELETE_SUCCESS": "Knowledge collection deleted.",
      "DELETE_SHARED_ERROR": "\"{{name}}\" can't be deleted because it's shared. Revoke its shares first, then delete it.",
      "DELETE_ERROR": "Couldn't delete the knowledge collection. Please try again.",
      "EMPTY_TITLE": "No knowledge collections yet",
      "EMPTY_DESCRIPTION": "Create one to organize your sources.",
      "EMPTY_FILTERED_TITLE": "No matching knowledge collections",
      "EMPTY_FILTERED_DESCRIPTION": "No knowledge collections match the current filter."
    },
    "SOURCE_TABLE": {
      "CREATE": "Add source",
      "COL_TYPE": "Type",
      "COL_NAME": "Name",
      "COL_DESCRIPTION": "Description",
      "COL_MANAGED_BY": "Managed by",
      "COL_LAST_MODIFIED": "Last modified",
      "ROW_ACTIONS": "Row actions",
      "REFRESH": "Refresh",
      "REMOVE_FROM_COLLECTION": "Remove from collection",
      "TRAINING_IN_PROGRESS": "Training in progress",
      "LAST_SCRAPED": "Last scraped: {{date}}",
      "AUTO_REFRESH_TOOLTIP": "Auto-refresh enabled. Next refresh: {{date}}",
      "AUTO_REFRESH_SCHEDULED": "scheduled",
      "EMPTY_TITLE": "No knowledge sources yet",
      "EMPTY_DESCRIPTION": "Add a source to give the AI information to draw on.",
      "EMPTY_FILTERED_TITLE": "No matching knowledge sources",
      "EMPTY_FILTERED_DESCRIPTION": "No knowledge sources match the current filter."
    }
  }
}
